import classNames from "classnames";
import { renderHtmlToReact } from "@/lib/util";
import { PropsWithChildren } from "react";

function List({ children }: PropsWithChildren) {
  return <li className="list-disc ml-4 pl-2">{children}</li>;
}

function OrderedList({ children }: PropsWithChildren) {
  return <ol className="list-decimal ml-4 pl-2">{children}</ol>;
}

export const DescriptionSection = ({
  item,
  section: { value },
  full,
}: {
  item: Travelguide.OOI;
  section: Travelguide.POISection.Description;
  full?: boolean;
}) => {
  return (
    <section
      className={classNames("flex flex-col gap-5 px-4", {
        "md:px-6": !full,
        "md:px-0": full,
      })}
    >
      <p className="font-bold">{item.shortText}</p>
      {renderHtmlToReact(value, { components: { li: List, ol: OrderedList } })}
    </section>
  );
};
